import { useCallback, useEffect, useMemo, useState } from 'react';
import liff from '@line/liff';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

import IconButton from '@mui/material/IconButton';

import { DateTime } from 'luxon';
import md5 from 'md5';
import { Box } from '@mui/material';
import { FacebookCircularProgress } from '../components/progress';
import Iconify from '../components/iconify/Iconify';
import UserService from '../services/user.service';

import { isLocalhost } from '../App';

const liffId = '1656457313-lvp7VeRR' // process.env.REACT_APP_LIFF_ID

function logOut() {
    liff.logout()
    // setSignedIn(false)
    window.location.reload()
}

function logIn() {
liff.login({ redirectUri: window.location.href })
}

async function getLineProfile() {
    const profile = await liff.getProfile()
    // document.getElementById("pictureUrl").style.display = "block"
    // document.getElementById("pictureUrl").src = profile.pictureUrl
    return profile
}


export default function QRCheckin() {
   
    const [profile, setProfile] = useState({});
    // const [scanning, setScanning] = useState(false);
    // const [log, setLog] = useState("LOG appears here");

    useEffect(() => {


        // let user
        // if (isLocalhost) {
    
        //     const profile = {
        //       userId: 'Ud8e7d090e9ec4d162733ba991e52f5db',
        //       displayName: 'Chaloemphol',
        //       statusMessage: 'ev’ry moment new',
        //       pictureUrl: '/assets/images/avatars/avatar_2.jpg',
        //     }
        //     setProfile(profile)
        // // })
        //   return undefined
        // }
    
        (async () => {
    
        //   if (isLocalhost) return
    
    
          await liff.init({ liffId, withLoginOnExternalBrowser: false})
    
          if (liff.isInClient()) {
            // window.alert('ok')
            await getLineProfile()
            .then( data => {
            
            //   let profile = data
            //   user = await getLineProfile(data.userId)
            //   if (user) profile = { ...user , ...profile }
                // window.alert(JSON.stringify(data))
              setProfile(data)
    
            })
    
          }
        })()
    
        return undefined
      }, []);


const readqr = useCallback (async () => {
  // setLog('Scanning...')
  // setScanning(true)
  try {
    const qrcoderesult = await liff.scanCodeV2();

    // setScanning(false)
    if (qrcoderesult) {
      const timestamp = qrcoderesult.value
      const time = DateTime.fromMillis(Number(timestamp))

      const params = {
        timestamp,
        user: {
          id: profile.userId
        }
      }
      // setLog(JSON.stringify(params))

      // TODO: check capacity if ok then send check-in button:

      if (time &&
        time > DateTime.local().minus({
          hour: 1
        }).startOf('hour').plus({
          minute: 30
        }) &&
        time < DateTime.local().endOf('hour').plus({
          minute: 30
        })) {


        await UserService.createWalkinRequest(params).then(r => {

          // liff.sendMessages([{
          //     type: 'text',
          //     text: t
          //   }])
          //   .then(liff.closeWindow())
          //   .catch(e => setLog(JSON.stringify(e)))
          if (r) {


            setTimeout(() => {
              
              liff.sendMessages([{
                type: 'text',
                text: 'เช็คอินด้วย QR CODE' // 'เริ่มต้นการเช็คอิน'
              }])
              .then(liff.closeWindow())
              .catch((error) => {
                window.alert(`Error sending message: ${error}`);
              });

            }, 500);

          } else {
            liff.sendMessages([{
                type: 'text',
                text: `เกิดข้ดผิดพลาดในการสแกนหรือรอบเต็ม กรุณาสอบถามที่เคาน์เตอร์`
              }])
              .then(liff.closeWindow())
          }
        })


      } else {
        liff.sendMessages([{
            type: 'text',
            text: 'เช็คอินด้วย QR CODE'
          }])
          .then(liff.closeWindow())
      }
    }

  } catch(error) {
    console.log('scanCodeV2', error);
    window.alert(error)
  }

  


  // liff.sendMessages({ messages: {
  //   type: 'text',
  //   text: 'ok'
  // }}).then( o => setLog(JSON.stringify(o)))
  // .catch(e => setLog(JSON.stringify(e)))
}, [profile])


// useEffect(() => {
//   if (profile && !scanning) {
//     readqr()    
//   }
// }, [profile, readqr, scanning]);


const info = useMemo(() => 
    // if (!isLocalhost && (!profile || !profile.displayName)) return (<Box sx={{ textAlign: 'center', width: '100%', pt: 20}} ><FacebookCircularProgress /></Box>)

     (<Box sx={{ textAlign: 'center'}}>
    <Card sx={{ maxWidth: '100%' }}>
        <CardMedia
          sx={{ height: 80 }}
          image='/assets/images/runway/logo_logo_th.png'
          title={profile.displayName}
        />
        <CardContent>
          <Typography gutterBottom variant="h4" component="div">
            ยินดีต้อนรับ {profile.displayName}            
          </Typography>
          <Typography variant="h5" color="text.secondary">
            SELF-CHECKIN ด้วย QR CODE
          </Typography>
          <Typography variant="body2" color="text.secondary">
            กดปุ่มด้านล่างและสแกน QR CODE บนหน้าจอทีวีด้านข้างเคาน์เตอร์
          </Typography>
        </CardContent>        
      </Card>
      {/* {log} */}
      <IconButton onClick={async () => readqr()} color="info" sx={{ bgcolor: 'darkblue', borderRadius: 2, mt: 2, mb: 2, p: 2}}>
            <Iconify icon="mdi:qrcode-scan" /> 
            <Typography sx={{ ml: 2}}>กดและสแกน QR CODE บนทีวี</Typography>
          </IconButton>


          <Box sx={{ m:1}}>
            <Typography variant="body2" color="text.secondary">
              {'หลังจากสแกนแล้ว ระบบจะเช็คอินให้อัตโนมัติ\nหากไม่สำเร็จ ให้กด "เช็คอิน > เช็คอินด้วย QR อีกครั้งหนึ่ง"'}
            </Typography>          
          </Box>
      </Box>
      
      ) 

, [profile, readqr])



return <>{info}</>
}